// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "lz-academy-583f3.firebaseapp.com",
  "projectId": "lz-academy-583f3",
  "storageBucket": "lz-academy-583f3.appspot.com",
  "messagingSenderId": "1088130223357",
  "appId": "1:1088130223357:web:9d7606a4f0be9ed7a64294",
  "apiKey": "AIzaSyDlCylVjT7T0yaWLikItpY7cr-p8me1f2Q"
};
